import styled, { css } from "styled-components";
import { type TypographyProps, type SpaceProps, color, space } from "styled-system";
import { type ThemeTypedColorProps, getBreakpoint } from "../../../../../themes/common";
import { theme } from "../../theme/toyotaTheme";

type TextType = { lineThrough?: boolean; isLarge?: boolean; isSmall?: boolean } & ThemeTypedColorProps &
    TypographyProps &
    SpaceProps;

export const PricesWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Text = styled.div<TextType>`
    display: inline-block;
    font-family: ${theme.fonts.regular};
    color: ${theme.colors.primaryBlack};
    cursor: default;
    ${({ isLarge }) =>
        isLarge &&
        css`
            margin-top: ${theme.space[2]}px;
            font-size: 1.8rem;
            line-height: 2.4rem;
        `};
    ${({ isSmall }) =>
        isSmall &&
        css`
            display: block;
            color: ${theme.colors.grey7};
        `};
    ${space};
    ${color};

    span {
        display: block;
        font-family: Arial, sans-serif;
        font-size: 1.4rem;
        line-height: 2rem;
        color: ${theme.colors.grey7};

        @media ${getBreakpoint("up", "xl")} {
            font-size: 1.6rem;
        }
    }

    span:not(:first-child):nth-last-child(1) {
        display: flex;
        align-items: center;
        font-size: 1.6rem;
        line-height: 2.4rem;
        color: ${theme.colors.primaryBlack};

        @media ${getBreakpoint("up", "xl")} {
            font-size: 1.8rem;
        }
    }

    span:first-child:last-child {
        font-size: 1.6rem;
    }
`;

export const SpanText = styled.div`
    white-space: nowrap;
`;

export const TextLineThrough = styled(Text)`
    font-size: 1.3rem;
    text-decoration: line-through;
    color: ${theme.colors.primaryBlack};
`;
